import { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { getData } from "../Services/getData";
import { enumUrl } from "../Utils/utils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ValidateInvalidateTable from "./ValidateInvalidateTable";
import { useLocation, useNavigate } from "react-router-dom";

function FormsTable() {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(0);
  const [isValidated, setIsValidated] = useState(false);
  const [validatedForms, setValidatedForms] = useState({
    forms: [],
    formsNumber: 0,
    page: 0,
    perPage: 10,
    search: null,
  });
  const [invalidatedForms, setInvalidatedForms] = useState({
    forms: [],
    formsNumber: 0,
    page: 0,
    perPage: 10,
    search: null,
  });
  const notifyError = (message) => toast.error(message);

  useEffect(() => {
    const search = location.search.split("?");
    const locationParams = {};
    search.forEach((value) => {
      if (value !== "") {
        const values = value.split("=");
        if (values[0] === "page") locationParams[values[0]] = +values[1] - 1;
        else
          locationParams[values[0]] = isNaN(+values[1])
            ? values[1]
            : +values[1];
      }
    });
    if (locationParams.isValidated === "true") {
      getValidatedForms(locationParams);
      setValue(1);
    } else {
      setValue(0);
      getInvalidatedForms(locationParams);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  /**
   *
   */
  async function getValidatedForms(locationParams) {
    //true if is validated
    const search = locationParams.search ? locationParams.search : null;
    let url = `${enumUrl.form}/${locationParams.isValidated}/${locationParams.page}/${locationParams.perPage}`;
    if (search) url += `/${search}`;
    await getData(url)
      .then((response) => {
        if (
          (response.status === 200 || response.status === 201) &&
          response.data
        ) {
          setValidatedForms({
            ...validatedForms,
            forms: response.data.forms,
            formsNumber: response.data.formsNumber,
            page: locationParams.page
              ? locationParams.page
              : validatedForms.page,
            perPage: locationParams.perPage
              ? locationParams.perPage
              : validatedForms.perPage,
            isValidated: locationParams.isValidated === "true",
            search: search,
          });
        }
      })
      .catch((err) => {
        notifyError(err.message);
      });
  }

  /**
   *
   */
  async function getInvalidatedForms(locationParams) {
    //false if is invalidated
    const search = locationParams.search ? locationParams.search : null;
    let url = `${enumUrl.form}/${locationParams.isValidated}/${locationParams.page}/${locationParams.perPage}`;
    if (search) url += `/${search}`;
    await getData(url)
      .then((response) => {
        if (
          (response.status === 200 || response.status === 201) &&
          response.data
        ) {
          setInvalidatedForms({
            ...invalidatedForms,
            forms: response.data.forms,
            formsNumber: response.data.formsNumber,
            page: locationParams.page
              ? locationParams.page
              : invalidatedForms.page,
            perPage: locationParams.perPage
              ? locationParams.perPage
              : invalidatedForms.perPage,
            isValidated: locationParams.isValidated === "true",
            search: search,
          });
        }
      })
      .catch((err) => {
        notifyError(err.message);
      });
  }

  /**
   *
   * @param {*} event
   * @param {*} newValue
   */
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setIsValidated(!isValidated);
    if (newValue) {
      navigate(
        `/?isValidated=${!!newValue}?page=${validatedForms.page + 1}?perPage=${
          validatedForms.perPage
        }`
      );
    } else {
      navigate(
        `/?isValidated=${!!newValue}?page=${
          invalidatedForms.page ? invalidatedForms.page + 1 : 1
        }?perPage=${
          invalidatedForms.perPage && invalidatedForms.perPage !== "undefined"
            ? invalidatedForms.perPage
            : 10
        }`
      );
    }
  };

  return (
    <div style={{ height: "90%", padding: "85px 20px 0px 20px" }}>
      <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
        <AppBar
          position="static"
          style={{ backgroundColor: "#f1f1f1", color: "black" }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            textColor="inherit"
            variant="fullWidth"
            aria-label="full width tabs example"
            TabIndicatorProps={{
              style: {
                background: "#f58638",
                color: "white",
              },
            }}
          >
            <Tab
              label="Formulare nevalidate"
              style={{
                background: "#f58638",
                color: "white",
              }}
            />
            <Tab
              label="Formulare validate"
              style={{
                background: "#f58638",
                color: "white",
              }}
            />
          </Tabs>
        </AppBar>
        <ValidateInvalidateTable
          setForms={setInvalidatedForms}
          forms={invalidatedForms}
          value={value}
          index={0}
          isValidated={false}
        />
        <ValidateInvalidateTable
          setForms={setValidatedForms}
          forms={validatedForms}
          value={value}
          index={1}
          isValidated={true}
        />
      </Box>
      <ToastContainer />
    </div>
  );
}

export default FormsTable;
